import { useQuery } from "react-query";
import { getAllEmployees } from "../../../../../actions/Employees";

const useGetAllEmployees = () => {
  return useQuery("GetAllEmployees", getAllEmployees, {
    refetchOnWindowFocus: false,
  });
};

export default useGetAllEmployees;
